import ResourceProxy from '@/zenky/resources/ResourceProxy';
import config from '@/../config/zenky';
import EditProductVariantForm from '@/resources/products/variants/forms/EditProductVariantForm';
import EditProductVariantFormSubmitter from '@/resources/products/variants/EditProductVariantFormSubmitter';
import ProductVariantMessages from '@/resources/products/variants/ProductVariantMessages';
import ResourceNotifications from '@/zenky/resources/ResourceNotifications';
import ProductVariantNotifications from '@/resources/products/variants/ProductVariantNotifications';
import ProductVariantSidebar from '@/resources/products/variants/ProductVariantSidebar';
import ProductsResource from '../ProductsResource';

export default class ProductVariantResourceProxy extends ResourceProxy {
  getProductId: () => string;
  constructor(getProductId: () => string) {
    super(new ProductsResource());
    this.getProductId = getProductId;
  }

  protected createNotifications(): ResourceNotifications {
    return new ProductVariantNotifications();
  }

  getShowApiUrl(itemId: string): string {
    return `products/${this.getProductId()}/variants/${itemId}?with=${config.api.includes.variants.show}`;
  }

  getDestroyApiUrl(itemId: string) {
    return `products/${this.getProductId()}/variants/${itemId}`;
  }

  getConfirmMessage(item: any): string {
    return new ProductVariantMessages().confirm(item);
  }

  getIndexRoute() {
    return {
      name: 'products.edit',
      params: {
        id: this.getProductId(),
      },
    };
  }

  getDestroyRoute(item: any) {
    return {
      name: 'products.variant.destroy',
      params: {
        id: this.getProductId(),
        variantId: item.id,
      },
    };
  }

  getEditForm(item: any) {
    return new EditProductVariantForm(item);
  }

  getEditFormSubmitter(item: any) {
    return new EditProductVariantFormSubmitter();
  }

  getSidebar(item: any) {
    return new ProductVariantSidebar();
  }
}
